import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { CheckCheckIcon, CheckIcon, MoreVerticalIcon, PhoneIcon, VideoIcon, ChevronLeftIcon, ChevronRightIcon, ArrowLeftIcon, LockIcon } from 'lucide-react';
type Receipt = 'sent' | 'delivered' | 'read';
interface Message {
  text: string;
  time: string;
  isOut: boolean;
  receipt?: Receipt;
}
interface ChatData {
  name: string;
  avatar: string;
  status: string;
  messages: Message[];
}
function Ticks({
  receipt
}: {
  receipt?: Receipt;
}) {
  if (!receipt) return null;
  if (receipt === 'sent') return <CheckIcon className="w-4 h-4 text-white/50" data-id="element-284" />;
  if (receipt === 'delivered') return <CheckCheckIcon className="w-4 h-4 text-white/50" data-id="element-285" />;
  return <CheckCheckIcon className="w-4 h-4 text-[#53bdeb]" data-id="element-286" />;
}
function WhatsAppChat({
  name,
  avatar,
  status,
  messages
}: ChatData) {
  return <div className="bg-[#0b141a] rounded-2xl overflow-hidden shadow-2xl border border-white/10 flex flex-col h-full" data-id="element-287">
      {/* Chat Header */}
      <div className="bg-[#202c33] px-3 py-2.5 flex items-center justify-between border-b border-black/30 shadow-sm z-10" data-id="element-288">
        <div className="flex items-center space-x-2.5 min-w-0" data-id="element-289">
          <ArrowLeftIcon className="w-5 h-5 text-[#aebac1] shrink-0 sm:hidden" data-id="element-290" />
          <img src={avatar} alt={name} className="w-10 h-10 rounded-full object-cover border border-white/10 shrink-0" data-id="element-291" />
          <div className="min-w-0" data-id="element-292">
            <div className="text-[#e9edef] font-medium text-sm sm:text-base font-sans truncate" data-id="element-293">
              {name}
            </div>
            <div className="text-[#8696a0] text-xs font-sans truncate" data-id="element-294">
              {status}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-4 text-[#aebac1] shrink-0" data-id="element-295">
          <VideoIcon className="w-5 h-5 hidden sm:block" data-id="element-296" />
          <PhoneIcon className="w-4 h-4 hidden sm:block" data-id="element-297" />
          <MoreVerticalIcon className="w-5 h-5" data-id="element-298" />
        </div>
      </div>

      {/* Chat Body */}
      <div className="flex-1 p-3 sm:p-4 relative" style={{
      backgroundColor: '#0b141a',
      backgroundImage: 'url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")',
      backgroundSize: '380px',
      backgroundBlendMode: 'overlay'
    }} data-id="element-299">
        {/* Date chip */}
        <div className="flex justify-center mb-3" data-id="element-300">
          <span className="bg-[#182229] text-[#8696a0] text-[11px] font-sans px-3 py-1 rounded-md shadow-sm uppercase tracking-wide" data-id="element-301">
            Today
          </span>
        </div>
        {/* Encryption notice */}
        <div className="flex justify-center mb-3" data-id="element-302">
          <span className="bg-[#182229]/90 text-[#ffd279]/90 text-[10px] sm:text-[11px] font-sans px-3 py-1.5 rounded-md shadow-sm flex items-center gap-1.5 text-center max-w-[90%]" data-id="element-303">
            <LockIcon className="w-3 h-3 shrink-0" data-id="element-304" />
            Messages are end-to-end encrypted.
          </span>
        </div>

        {messages.map((msg, i) => {
        const prev = messages[i - 1];
        const grouped = !!prev && prev.isOut === msg.isOut;
        const tail = !grouped;
        const corner = msg.isOut ? tail ? 'rounded-tr-none' : '' : tail ? 'rounded-tl-none' : '';
        return <div key={i} className={`flex ${msg.isOut ? 'justify-end' : 'justify-start'} ${grouped ? 'mt-0.5' : 'mt-2'}`} data-id="element-305">
              <div className={`max-w-[85%] sm:max-w-[78%] rounded-lg px-2.5 py-1.5 shadow-sm font-sans relative ${corner} ${msg.isOut ? 'bg-[#005c4b] text-[#e9edef]' : 'bg-[#202c33] text-[#e9edef]'}`} data-id="element-306">
                <p className="text-[14.5px] leading-snug pr-12" data-id="element-307">
                  {msg.text}
                  <span className="inline-flex items-center space-x-1 float-right ml-2 translate-y-1.5" data-id="element-308">
                    <span className="text-[10px] text-white/55" data-id="element-309">
                      {msg.time}
                    </span>
                    {msg.isOut && <Ticks receipt={msg.receipt} data-id="element-310" />}
                  </span>
                </p>
              </div>
            </div>;
      })}
      </div>
    </div>;
}
const chats: ChatData[] = [{
  name: 'Sarah M.',
  status: 'online',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop',
  messages: [{
    text: 'OMG we just finished Maple Street 😭🔥',
    time: '10:42 PM',
    isOut: false
  }, {
    text: 'we spent two HOURS arguing about the neighbor lol',
    time: '10:43 PM',
    isOut: false
  }, {
    text: "haha that's literally the best part 😂 did you solve it?",
    time: '10:45 PM',
    isOut: true,
    receipt: 'read'
  }, {
    text: 'best date night in YEARS. already buying the next one 🕵️‍♀️',
    time: '10:46 PM',
    isOut: false
  }]
}, {
  name: 'James & Carla',
  status: 'last seen today at 11:24 PM',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=150&auto=format&fit=crop',
  messages: [{
    text: 'are you guys dropping a new case soon??',
    time: '11:15 PM',
    isOut: false
  }, {
    text: 'we literally threw our phones in a drawer and played for 3 hours',
    time: '11:15 PM',
    isOut: false
  }, {
    text: 'working on it! glad you loved the screen-free time 🔦',
    time: '11:20 PM',
    isOut: true,
    receipt: 'read'
  }, {
    text: 'nothing has brought us together like this. getting the bundle!!',
    time: '11:22 PM',
    isOut: false
  }]
}, {
  name: 'David K.',
  status: 'online',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop',
  messages: [{
    text: 'just wanted to say thank you guys 👏',
    time: '9:30 PM',
    isOut: false
  }, {
    text: 'my teenagers actually put their phones down. for three whole hours.',
    time: '9:31 PM',
    isOut: false
  }, {
    text: 'that might be the real mystery solved right there 😂',
    time: '9:35 PM',
    isOut: true,
    receipt: 'read'
  }, {
    text: 'honestly!! that alone is worth every penny.',
    time: '9:36 PM',
    isOut: false
  }]
}, {
  name: 'Maria L.',
  status: 'last seen today at 12:14 AM',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=150&auto=format&fit=crop',
  messages: [{
    text: 'The Hollow Man Files DESTROYED us 😱',
    time: '12:08 AM',
    isOut: false
  }, {
    text: 'we were SO sure it was the brother',
    time: '12:09 AM',
    isOut: false
  }, {
    text: 'the twist hit different right? 🔪',
    time: '12:11 AM',
    isOut: true,
    receipt: 'read'
  }, {
    text: 'we SCREAMED. best $17 I have ever spent. buying all four now.',
    time: '12:12 AM',
    isOut: false
  }]
}, {
  name: 'Tom B.',
  status: 'online',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=150&auto=format&fit=crop',
  messages: [{
    text: 'did Frequency with my college friends last night',
    time: '8:50 PM',
    isOut: false
  }, {
    text: 'the hidden messages in the recording?? GENIUS 🎧',
    time: '8:51 PM',
    isOut: false
  }, {
    text: 'so you found them all then? 😏',
    time: '8:54 PM',
    isOut: true,
    receipt: 'read'
  }, {
    text: 'took us 3 hours and a LOT of yelling but YES. unreal night.',
    time: '8:55 PM',
    isOut: false
  }]
}];
function getPerView(width: number) {
  if (width >= 1024) return 3;
  if (width >= 640) return 2;
  return 1;
}
export function Testimonials() {
  const [perView, setPerView] = useState(1);
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const update = () => setPerView(getPerView(window.innerWidth));
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  const maxIndex = Math.max(0, chats.length - perView);
  useEffect(() => {
    setIndex(i => Math.min(i, maxIndex));
  }, [maxIndex]);
  const next = useCallback(() => {
    setIndex(i => i >= maxIndex ? 0 : i + 1);
  }, [maxIndex]);
  const prev = useCallback(() => {
    setIndex(i => i <= 0 ? maxIndex : i - 1);
  }, [maxIndex]);
  useEffect(() => {
    if (isPaused) return;
    const id = setInterval(next, 5000);
    return () => clearInterval(id);
  }, [next, isPaused]);
  return <section id="reviews" className="py-16 sm:py-24 lg:py-32 bg-[#121212] relative overflow-hidden" data-id="element-311">
      <div className="absolute inset-0 bg-noise opacity-10 mix-blend-overlay pointer-events-none" data-id="element-312" />

      {/* Bordó glow background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[700px] max-w-[120vw] bg-[#8b1a1a]/20 rounded-full blur-[140px] pointer-events-none" data-id="element-313" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] max-w-[90vw] bg-[#8b1a1a]/15 rounded-full blur-[90px] pointer-events-none" data-id="element-314" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-315">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 sm:mb-16" data-id="element-316">
          <h2 className="font-typewriter text-3xl sm:text-5xl lg:text-6xl text-[#ece3d0] mb-3 sm:mb-6 drop-shadow-lg" data-id="element-317">
            The debrief
          </h2>
          <p className="font-serif-body text-[#ece3d0]/70 text-base sm:text-xl" data-id="element-318">
            Real messages from detectives who opened the files.
          </p>
        </motion.div>

        {/* Carousel */}
        <div className="relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-319">
          <div ref={containerRef} className="overflow-hidden" data-id="element-320">
            <motion.div className="flex items-stretch" animate={{
            x: `-${index * (100 / perView)}%`
          }} transition={{
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }} data-id="element-321">
              {chats.map((chat, i) => <div key={i} className="shrink-0 px-2.5 sm:px-4" style={{
              width: `${100 / perView}%`
            }} data-id="element-322">
                  <WhatsAppChat {...chat} data-id="element-323" />
                </div>)}
            </motion.div>
          </div>

          {/* Arrows */}
          <button onClick={prev} aria-label="Previous testimonials" className="absolute -left-2 sm:-left-5 top-1/2 -translate-y-1/2 z-20 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#0a0a0a]/80 border border-[#8b1a1a]/50 text-[#ece3d0] flex items-center justify-center backdrop-blur-sm shadow-[0_0_20px_rgba(139,26,26,0.4)] hover:bg-[#8b1a1a] transition-colors focus:outline-none focus:ring-2 focus:ring-[#8b1a1a]" data-id="element-324">
            <ChevronLeftIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-325" />
          </button>
          <button onClick={next} aria-label="Next testimonials" className="absolute -right-2 sm:-right-5 top-1/2 -translate-y-1/2 z-20 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#0a0a0a]/80 border border-[#8b1a1a]/50 text-[#ece3d0] flex items-center justify-center backdrop-blur-sm shadow-[0_0_20px_rgba(139,26,26,0.4)] hover:bg-[#8b1a1a] transition-colors focus:outline-none focus:ring-2 focus:ring-[#8b1a1a]" data-id="element-326">
            <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-327" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2.5 mt-8" data-id="element-328">
          {Array.from({
          length: maxIndex + 1
        }).map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Go to testimonial group ${i + 1}`} className={`h-2.5 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-[#8b1a1a] ${i === index ? 'w-8 bg-[#8b1a1a] shadow-[0_0_10px_rgba(139,26,26,0.7)]' : 'w-2.5 bg-[#ece3d0]/30 hover:bg-[#ece3d0]/50'}`} data-id="element-329" />)}
        </div>
      </div>
    </section>;
}